import Project from 'Playground/Project'
import StarPatternsProject from './StarPatterns/StarPatternsProject'

/**
 * Add new projects here
 */
const ALL: Project<any, any>[] = [
  // Islamic Stars
  new StarPatternsProject(),
]

export default { ALL }
